import { useState } from 'react';
import Icon from '../../common/Icon/Icon';
import { IconKeys } from '../../common/Icon/IconKeys';

function WeatherAnnouncement(): JSX.Element {
  const getTime = (): string => {
    const date = (new Date()).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const time = (new Date()).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return `${time} ${date}`;
  };

  const [time, setNewTime] = useState(getTime());

  setInterval(() => {
    setNewTime(getTime());
  }, 10000);

  return (
    <>
      <Icon iconKey={IconKeys.WEATHER} />
      <p>{time}</p>
    </>
  );
}

export default WeatherAnnouncement;
